import React, { useContext, useState } from 'react';
import { ZdsDivider, ZdsItem } from '@zig-design-system/ui-components-react';
import { RootContext } from '../../../Context/RootContext';
const RealEstateResult = ({ hit, imageUrl, title, content, contentEnd }) => {
    const assetPaths = useContext(RootContext).assetPaths;
    const [imageNotFoundError, setImageNotFoundError] = useState(false);
    const imageSrc = imageNotFoundError || !imageUrl ? `${assetPaths.sitepackage}/Images/imagenotfound_4x3.jpg` : imageUrl;
    return (React.createElement("div", null,
        React.createElement(ZdsItem, { link: hit._source.url },
            React.createElement("div", { slot: "content-start", className: "search-list-image" },
                React.createElement("img", { src: imageSrc, alt: hit._source.title, onError: ({ currentTarget }) => {
                        if (!imageNotFoundError) {
                            currentTarget.src = imageSrc;
                            setImageNotFoundError(true);
                        }
                    } })),
            React.createElement("div", { slot: "primary-text", className: "zds-bold zds-truncate" }, title),
            content && (React.createElement("div", { slot: "secondary-text", className: "zds-truncate" }, content)),
            contentEnd && (React.createElement("div", { slot: "content-end", className: "zds-hidden sm:zds-block zds-bold zds-self-end" }, contentEnd))),
        React.createElement(ZdsDivider, { className: "zds-margin-y-0" })));
};
export default RealEstateResult;
